/**
 * REDLINE: a sector past its safe limit (docs/REDLINE.md). The same
 * geometry under a hard countdown, no checkpoints, hazards retuned to
 * spec, and its own records. Pure functions: the derived def is built
 * here and node-tested; the game only decides when to use it.
 */

export const REDLINE_PREFIX = 'r-';
export const redlineKey = (id) => `${REDLINE_PREFIX}${id}`;
export const isRedlineKey = (key) => typeof key === 'string' && key.startsWith(REDLINE_PREFIX);
export const hasRedline = (def) => Number.isFinite(def?.redline?.seconds) && def.redline.seconds > 0;

/**
 * The derived def. `tune` applies per prefab type to every matching
 * object (a sentinel's reach and lock, a crusher's period), `objects`
 * are appended, `portalDecay` overrides. The base def is never mutated:
 * a redline run followed by a normal run must see stock numbers.
 */
export function redlineDef(def) {
  const rl = def.redline;
  if (!hasRedline(def)) throw new Error(`no redline on ${def.id}`);
  const tune = rl.tune ?? {};
  const objects = def.objects.map((o) => (tune[o.t] ? { ...o, ...tune[o.t] } : o));
  if (Array.isArray(rl.objects)) objects.push(...rl.objects);
  return {
    ...def,
    name: `${def.name} // REDLINE`,
    blurb: rl.blurb ?? `${rl.seconds}s on the clock. No checkpoints.`,
    objects,
    portalDecay: rl.portalDecay ?? def.portalDecay,
    // The clock rides the mode config; par stays for reference only.
    mode: { ...(def.mode ?? {}), redline: rl.seconds },
  };
}

/** Medals come from the clock, not par: gold under three quarters of
 *  it, silver under nine tenths, bronze for the clear. */
export function redlineMedal(seconds, time) {
  if (time <= seconds * 0.75) return 'gold';
  if (time <= seconds * 0.9) return 'silver';
  return 'bronze';
}
